/* eslint-disable  */
import React, { useEffect, useRef, useState } from "react";
import { BiSupport } from "react-icons/bi";
import { BsCalendar2DateFill } from "react-icons/bs";
import { GrStatusInfo } from "react-icons/gr";
import { MdOutlineUpdate, MdSend, MdEdit, MdArrowBack } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import {
  authActionCreators,
  messageActionCreators,
} from "../../services/Actions";
import RenderLoanPage from "../RenderLoanPage";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import PromptModal from "../../AdminModel/Components/PromptModal";
import { io } from "socket.io-client";

function LoansMessagesDetailed() {
  const history = useHistory();
  const dispatch = useDispatch();
  const chat_id = history.location?.state?.chat_id;
  const routeUserData = history.location?.state?.userData;
  const routeReference = history.location?.state?.reference;
  const routeSubject = history.location?.state?.subject;
  const routeDepartment = history.location?.state?.department;
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);
  const {
    getMessageDetailed,
    addMessageBySystemUser,
    EditMessageBySystemUser,
    DeleteMessageBySystemUser,
    ResetMessagesResponse,
  } = bindActionCreators(messageActionCreators, dispatch);
  const [formData, setFormData] = useState({ message: "" });
  const scrollRef = useRef();
  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target.value });
  };
  const auth = useSelector((state) => state?.auth);
  const messages = useSelector((state) => state?.message);
  const [openEditMessageFormModal, setOpenEditMessageFormModal] =
    useState(false);
  const [editedMessage, setEditedMessage] = useState("");
  const [messageId, setMessageId] = useState(null);


  const { message, isLoading, messageDetailed, response } = messages;

  console.log("messageDetailed", messageDetailed);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.message === "") {
      toast.error("message box is empty");
    } else {
      const payload = {
        ...formData,
        system_user: auth?.user?._id,
        system_user_name: auth?.user?.name,
        system_user_profile: auth?.user?.profile_image,
        reference: messageDetailed?.reference || routeReference,
      };
      addMessageBySystemUser(payload);
      setFormData({ ...formData, message: "" });
      // Server emits message:new to the conversation room — no manual socket emit needed
    }
  };

  const handleFormSaveEdited = (message_id) => {
    const payload = {
      message: editedMessage,
      system_user: auth?.user?._id,
      system_user_name: auth?.user?.name,
      system_user_profile: auth?.user?.profile_image,
      reference: messageDetailed?.reference || routeReference,
    };
    console.log("messageId", messageId);
    EditMessageBySystemUser(payload, messageId);
    setOpenEditMessageFormModal(false);
  };
  const handleDeleteSingleMessage = (message_id) => {
    const payload = {
      message: editedMessage,
      system_user: auth?.user?._id,
      system_user_name: auth?.user?.name,
      system_user_profile: auth?.user?.profile_image,
      reference: messageDetailed?.reference || routeReference,
    };
    console.log("messageId", messageId);
    DeleteMessageBySystemUser(payload, messageId);
  };

  useEffect(() => {
    GetUserProfile();
  }, []);
  useEffect(() => {
    getMessageDetailed(chat_id);
  }, [chat_id]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messageDetailed?.chat]);

  useEffect(() => {
    if (response.state === "SUCCESS") {
      // Message appended via socket — just reset response state
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    } else if (response.state === "ERROR") {
      toast.error(response?.message ?? "unable to get notification");
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    }
  }, [response.state, response?.message]);

  // Socket.IO: join conversation room, receive new messages incrementally
  useEffect(() => {
    if (!chat_id || !auth?.user?._id) return;

    const socket = io("https://api.upnmg.com", {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
    });

    const register = () => {
      socket.emit("user:register", { userId: auth.user._id });
      socket.emit("conversation:join", { conversationId: chat_id });
    };

    socket.on("connect", register);
    socket.on("reconnect", register);

    socket.on("message:new", (newMsg) => {
      dispatch({ type: "APPEND_CHAT_MESSAGE", payload: newMsg });
    });

    return () => {
      socket.emit("conversation:leave", { conversationId: chat_id });
      socket.disconnect();
    };
  }, [chat_id, auth?.user?._id]);

  return (
    <div className="min-h-screen bg-gray-50">
      <RenderLoanPage>
        {isLoading && <Loader />}

        {/* Header */}
        <div className="bg-white shadow-sm border-b sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <button
                onClick={() => history.goBack()}
                className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <MdArrowBack className="w-4 h-4" />
                Back
              </button>
              <h1 className="text-xl font-semibold text-gray-900 truncate">
                {messageDetailed?.title || messageDetailed?.subject || routeSubject}
              </h1>
              <div className="w-20"></div> {/* Spacer for centering */}
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Message Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <GrStatusInfo className="w-5 h-5 text-blue-600" />
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                    Member Staff ID
                  </p>
                  <p className="text-sm font-semibold text-gray-900 truncate">
                    {messageDetailed?.user?.staff_id || routeUserData?.staff_id}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <BiSupport className="w-5 h-5 text-green-600" />
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                    Department
                  </p>
                  <p className="text-sm font-semibold text-gray-900 truncate">
                    {messageDetailed?.system_user || routeDepartment}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                    <MdOutlineUpdate className="w-5 h-5 text-orange-600" />
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                    Last Updated
                  </p>
                  <p className="text-sm font-semibold text-gray-900">
                    {messageDetailed?.updated_at && moment(messageDetailed.updated_at).isValid() ? moment(messageDetailed.updated_at).format("MMM Do YY") : "—"}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                    <BsCalendar2DateFill className="w-5 h-5 text-purple-600" />
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                    Submitted On
                  </p>
                  <p className="text-sm font-semibold text-gray-900">
                    {messageDetailed?.created_at && moment(messageDetailed.created_at).isValid() ? moment(messageDetailed.created_at).format("MMM Do YY") : "—"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Chat Container */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                💬 Message Area
              </h2>
            </div>

            {/* Messages */}
            <div className="h-96 overflow-y-auto p-4 space-y-4 bg-gray-50">
              {messageDetailed?.chat?.map((ch, index) => {
                return ch?.user_type === "system_user" ? (
                  // Admin/System Message (Right side)
                  <div ref={scrollRef} key={index} className="flex justify-end">
                    <div className="flex flex-col items-end gap-1 max-w-xs lg:max-w-md">
                      {ch?.system_user && (
                        <span className="text-xs text-gray-500 mr-10">
                          {ch.system_user}
                        </span>
                      )}
                      <div className="flex items-end gap-2">
                        <div className="bg-blue-600 text-white rounded-2xl rounded-br-md px-4 py-3 shadow-sm">
                          <p className="text-sm leading-relaxed">{ch?.message}</p>
                          <div className="flex items-center justify-between mt-2 pt-2 border-t border-blue-500">
                            <span className="text-xs text-blue-100">
                              {ch?.data ? moment(ch.data).format("MMM Do YY") : "—"}
                            </span>
                            <button
                              onClick={() => {
                                setOpenEditMessageFormModal(true);
                                setEditedMessage(ch?.message);
                                setMessageId(ch?._id);
                              }}
                              className="ml-2 p-1 hover:bg-blue-500 rounded-full transition-colors"
                              title="Edit message"
                            >
                              <MdEdit className="w-3 h-3 text-blue-100" />
                            </button>
                          </div>
                        </div>
                        <div className="flex-shrink-0">
                          {/* Per-entry avatar saved at send time, so a thread
                              answered by two officers shows each one. Falls
                              back to the signed-in user for older entries. */}
                          <img
                            className="w-8 h-8 rounded-full object-cover border-2 border-white shadow-sm"
                            src={
                              ch?.system_user_profile ||
                              auth?.user?.profile_image ||
                              "/images/dev/avarta2.jpeg"
                            }
                            onError={(e) => {
                              e.currentTarget.src = "/images/dev/avarta2.jpeg";
                            }}
                            alt="System user profile"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Member Message (Left side)
                  <div
                    ref={scrollRef}
                    key={index}
                    className="flex justify-start"
                  >
                    <div className="flex items-end gap-2 max-w-xs lg:max-w-md">
                      <div className="flex-shrink-0">
                        <img
                          className="w-8 h-8 rounded-full object-cover border-2 border-white shadow-sm"
                          src={
                            ch?.member_profile ||
                            messageDetailed?.user?.profile_image ||
                            routeUserData?.profile_image ||
                            "/images/dev/avarta2.jpeg"
                          }
                          onError={(e) => {
                            e.currentTarget.src = "/images/dev/avarta2.jpeg";
                          }}
                          alt="Member profile"
                        />
                      </div>
                      <div className="bg-white border border-gray-200 rounded-2xl rounded-bl-md px-4 py-3 shadow-sm">
                        <p className="text-sm text-gray-800 leading-relaxed">
                          {ch?.message}
                        </p>
                        <p className="text-xs text-gray-500 mt-2 pt-2 border-t border-gray-100">
                          {ch?.data ? moment(ch.data).format("MMM Do YY") : "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Message Input */}
            <div className="border-t border-gray-200 bg-white p-4">
              <form onSubmit={handleSubmit} className="flex items-end gap-3">
                <div className="flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSubmit(e);
                        }
                      }}
                      name="message"
                      value={formData.message || ""}
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all"
                      placeholder="Type your message here..."
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="flex-shrink-0 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-2xl transition-colors shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={!formData.message?.trim()}
                >
                  <MdSend className="w-5 h-5" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </RenderLoanPage>

      {/* Edit Modal */}
      {openEditMessageFormModal && (
        <PromptModal
          closeModal={setOpenEditMessageFormModal}
          width={"40%"}
          title="Edit Message"
          height={"30vh"}
        >
          <div className="relative">
            <div className="p-6 text-center">
              <div className="mb-6">
                <label
                  htmlFor="message"
                  className="block mb-3 text-sm font-medium text-gray-700"
                >
                  Edit your message
                </label>
                <textarea
                  id="message"
                  rows="4"
                  defaultValue={editedMessage}
                  onChange={(e) => setEditedMessage(e.target.value)}
                  className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Edit your message..."
                />
              </div>

              <div className="flex justify-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    handleFormSaveEdited();
                  }}
                  className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors focus:ring-4 focus:ring-blue-300"
                >
                  Save Changes
                </button>
                <button
                  type="button"
                  className="px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors focus:ring-4 focus:ring-gray-300"
                  onClick={() => setOpenEditMessageFormModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </PromptModal>
      )}
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default LoansMessagesDetailed;
